import { ASKFLIPT_PROMPT } from '../prompts/askflipt';

export function buildAskFliptSystemContext(): string {
    return `\n\n[System: ${ASKFLIPT_PROMPT}]\n`;
}
